// Pure date + number + percentage helpers extracted from
// BusinessAnalytics.jsx during Step 4.1. No app-specific logic — all
// callable from any module. Other pages keep their own local copies
// of same-named helpers for now; a later phase can consolidate.

export function getDateRange(startDate, endDate) {
  const dates = []
  const d = new Date(startDate + 'T00:00:00')
  const end = new Date(endDate + 'T00:00:00')
  while (d <= end) {
    dates.push(d.toISOString().split('T')[0])
    d.setDate(d.getDate() + 1)
  }
  return dates
}

export function getWeekNumber(dateStr) {
  const d = new Date(dateStr + 'T00:00:00')
  d.setHours(0, 0, 0, 0)
  d.setDate(d.getDate() + 3 - ((d.getDay() + 6) % 7))
  const week1 = new Date(d.getFullYear(), 0, 4)
  return 1 + Math.round(((d - week1) / 86400000 - 3 + ((week1.getDay() + 6) % 7)) / 7)
}

export function getPreviousPeriod(startDate, endDate) {
  const s = new Date(startDate + 'T00:00:00')
  const e = new Date(endDate + 'T00:00:00')
  const days = Math.round((e - s) / 86400000) + 1
  const prevEnd = new Date(s)
  prevEnd.setDate(prevEnd.getDate() - 1)
  const prevStart = new Date(prevEnd)
  prevStart.setDate(prevStart.getDate() - days + 1)
  return {
    start: prevStart.toISOString().split('T')[0],
    end: prevEnd.toISOString().split('T')[0]
  }
}

export function getDayName(dateStr) {
  return new Date(dateStr + 'T00:00:00').toLocaleDateString('en-US', { weekday: 'short' })
}

export function getDayOfMonth(dateStr) {
  return new Date(dateStr + 'T00:00:00').getDate()
}

export function getMonthKey(dateStr) {
  return dateStr.slice(0, 7)
}

export function formatShortDate(dateStr) {
  const [y, m, d] = dateStr.split('-')
  return `${d}/${m}`
}

export function formatMonthLabel(monthKey) {
  const [y, m] = monthKey.split('-')
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  return `${months[parseInt(m) - 1]} ${y}`
}

export function pct(value, total) {
  if (!total) return 0
  return (value / total) * 100
}

export function fmtPct(value) {
  if (value === null || value === undefined) return '--'
  return `${Number(value).toFixed(1)}%`
}

export function colorForChange(val) {
  if (val > 0) return 'text-green-400'
  if (val < 0) return 'text-red-400'
  return 'text-gray-400'
}
